const getInitialState = () => {
  return {
    date: [],
    titleReport: ''
  }
}

const state = getInitialState()

const getters = {
  getDate: state => state.date,
  getTitleReport: state => state.titleReport || 'Laporan'
}

const mutations = {
  setDate (store, data) {
    store['date'] = data
  },
  setTitleReport (store, data) {
    store['titleReport'] = data
  },
  resetState (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getInitialState())
  }
}

export default {
  namespaced: true,
  getters,
  state,
  mutations
}
